import { render, staticRenderFns } from "./currency-exchange-resource-item-3-find-customers-searching-for-a-currency-exchange.vue?vue&type=template&id=41fc844c&scoped=true&"
import script from "./currency-exchange-resource-item-3-find-customers-searching-for-a-currency-exchange.vue?vue&type=script&lang=ts&"
export * from "./currency-exchange-resource-item-3-find-customers-searching-for-a-currency-exchange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fc844c",
  null
  
)

export default component.exports